import "./index.scss";

const HomeShapes = () => (
  <div className="pdl_component_home_shapes p-0 d-flex flex-column w-100 mx-auto">
    <div className="d-flex flex-row align-items-center justify-content-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="53"
        height="152"
        viewBox="0 0 53 152"
        fill="none"
      >
        <rect
          width="152"
          height="152"
          transform="translate(-99)"
          fill="white"
        />
        <rect x="-23" y="76" width="76" height="76" fill="#AE3333" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#D18A8A" />
        <path d="M152 0V152H0L152 0Z" fill="#8C0000" />
        <circle cx="76" cy="76" r="38" fill="white" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="white" />
        <path d="M76 76H152L76 152V76Z" fill="#AE3333" />
        <path d="M76 0V76H0L76 0Z" fill="#AE3333" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#D18A8A" />
        <path d="M0 76H76C76 117.974 41.9736 152 0 152V76Z" fill="white" />
        <path d="M76 0C117.974 0 152 34.0264 152 76H76V0Z" fill="#8C0000" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="white" />
        <path
          d="M152 152C110.026 152 76 117.974 76 76C76 34.0264 110.026 0 152 0V152Z"
          fill="#8C0000"
        />
        <circle cx="38" cy="76" r="38" fill="#D18A8A" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#D18A8A" />
        <path
          d="M0 152C41.9736 152 76 117.974 76 76C76 34.0264 41.9736 0 0 0V152Z"
          fill="#8C0000"
        />
        <path
          d="M152 -1.85809e-05L152 152L76 76L152 -1.85809e-05Z"
          fill="white"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#E0B0B0" />
        <path d="M76 76L76 0L152 76L76 76Z" fill="white" />
        <path d="M0 76L76 76V152L0 76Z" fill="#AE3333" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="53"
        height="152"
        viewBox="0 0 53 152"
        fill="none"
      >
        <rect width="152" height="152" fill="white" />
        <path
          d="M-6.64413e-06 0L152 -6.64413e-06L152 152L-6.64413e-06 0Z"
          fill="#AE3333"
        />
        <circle cx="76" cy="76" r="38" fill="#8C0000" />
      </svg>
    </div>
    <div className="d-flex flex-row align-items-center justify-content-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="53"
        height="152"
        viewBox="0 0 53 152"
        fill="none"
      >
        <rect
          width="152"
          height="152"
          transform="translate(-99)"
          fill="#E0B0B0"
        />
        <circle cx="-23" cy="76" r="38" fill="white" />
        <path d="M53 152H-99L-23 76L53 152Z" fill="#8C0000" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="white" />
        <path
          d="M152 76H76C76 117.974 110.026 152 152 152V76Z"
          fill="#AE3333"
        />
        <path d="M76 0C117.974 0 152 34.0264 152 76H76V0Z" fill="#8C0000" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#D18A8A" />
        <path
          d="M76 152C34.0264 152 0 117.974 0 76C0 34.0264 34.0264 0 76 0V152Z"
          fill="#8C0000"
        />
        <circle cx="76" cy="76" r="38" fill="white" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#E0B0B0" />
        <path
          d="M76 76H152C152 117.974 117.974 152 76 152V76Z"
          fill="#AE3333"
        />
        <path d="M76 76C34.0264 76 0 110.026 0 152H76V76Z" fill="#8C0000" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#E0B0B0" />
        <path
          d="M-3.32207e-06 76C-1.48734e-06 34.0263 34.0264 -5.15679e-06 76 -3.32207e-06C117.974 -1.48734e-06 152 34.0264 152 76L-3.32207e-06 76Z"
          fill="#AE3333"
        />
        <ellipse cx="76" cy="114" rx="38" ry="38" fill="white" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="white" />
        <path
          d="M-3.32207e-06 76C-1.48734e-06 34.0263 34.0264 -5.15679e-06 76 -3.32207e-06C117.974 -1.48734e-06 152 34.0264 152 76L-3.32207e-06 76Z"
          fill="#AE3333"
        />
        <path
          d="M76 152C34.0264 152 0 117.974 0 76C0 34.0264 34.0264 0 76 0L76 152Z"
          fill="#8C0000"
        />
        <ellipse cx="114" cy="114" rx="38" ry="38" fill="#D18A8A" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
      >
        <rect width="152" height="152" fill="#E0B0B0" />
        <rect width="76" height="76" fill="#8C0000" />
        <rect x="76" y="76" width="76" height="76" fill="white" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="53"
        height="152"
        viewBox="0 0 53 152"
        fill="none"
      >
        <rect width="152" height="152" fill="white" />
        <circle cx="76" cy="76" r="38" fill="#F5E6E6" />
        <path d="M152 152H0L76 76L152 152Z" fill="#8C0000" />
        <path d="M152 76H0L76 0L152 76Z" fill="#AE3333" />
      </svg>
    </div>
  </div>
);

export default HomeShapes;
